module.exports = __webpack_public_path__ + "static/media/SourceSansPro-Black.9ded577f.ttf";